import { Stack, Typography } from '@mui/material';

interface NoResultsProps {
    message?: string;
    height?: string;
    width?: string;
}
const defaultMessage = 'No results found.';

const styles = {
    fontSize: 20,
    textAlign: 'center',
    color: 'gray',
};

const NoResults = ({ message, height, width }: NoResultsProps) => {
    return (
        <Stack width={width || '100%'} height={height || '200px'} justifyContent="center" alignItems="center">
            <Typography variant="body1" sx={{ ...styles }}>
                {message || defaultMessage}
            </Typography>
        </Stack>
    );
};

export default NoResults;
